import React, { useState, useContext, useRef, useEffect } from 'react';
import ReactDOM from 'react-dom';
import classes from './HamburgerMenu.module.css';
import { signOut } from 'firebase/auth';
import { doc, updateDoc } from 'firebase/firestore';
import { ref as storageRef, uploadBytes, getDownloadURL } from 'firebase/storage';
import { auth, db, storage } from '../../config';
import { UserContext } from '../../store/user-context';
import { AuthenticatedUserContext } from '../../providers';
import Page from '../Modals/Page';
import EventsSheet from './EventsSheet';
import MyProfile from './MyProfile';

const XIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
    <path d="M18 6L6 18M6 6L18 18" stroke="#565959" strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

const UserIcon = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
    <circle cx="12" cy="8" r="4" stroke="#808383" strokeWidth="1.8"/>
    <path d="M4 20C4 16.686 7.582 14 12 14C16.418 14 20 16.686 20 20" stroke="#808383" strokeWidth="1.8" strokeLinecap="round"/>
  </svg>
);

const MENU_ICONS = {
  profile: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="8" r="4" stroke="#808383" strokeWidth="1.8"/>
      <path d="M4 20C4 16.686 7.582 14 12 14C16.418 14 20 16.686 20 20" stroke="#808383" strokeWidth="1.8" strokeLinecap="round"/>
    </svg>
  ),
  events: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
      <rect x="3" y="4" width="18" height="18" rx="2" stroke="#808383" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M16 2v4M8 2v4M3 10h18" stroke="#808383" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  about: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="12" r="9" stroke="#808383" strokeWidth="1.8"/>
      <path d="M12 8v1M12 11v5" stroke="#808383" strokeWidth="1.8" strokeLinecap="round"/>
    </svg>
  ),
  resources: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
      <path d="M14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8L14 2Z" stroke="#808383" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  partners: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75" stroke="#808383" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  terms: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" stroke="#808383" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  contact: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
      <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" stroke="#808383" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  help: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="12" r="9" stroke="#808383" strokeWidth="1.8"/>
      <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3M12 17h.01" stroke="#808383" strokeWidth="1.8" strokeLinecap="round"/>
    </svg>
  ),
  logout: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
      <path d="M9 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H9M16 17L21 12M21 12L16 7M21 12H9" stroke="#808383" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  signup: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
      <path d="M15 3H19C19.5304 3 20.0391 3.21071 20.4142 3.58579C20.7893 3.96086 21 4.46957 21 5V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H15M10 17L15 12M15 12L10 7M15 12H3" stroke="#808383" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
};

const ChevronIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
    <path d="M9 6L15 12L9 18" stroke="#c0c8c8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const MenuItem = ({ icon, label, onClick, danger, rightLabel }) => (
  <button className={`${classes.menuItem} ${danger ? classes.menuItemDanger : ''}`} onClick={onClick}>
    <span className={classes.menuItemIcon}>{icon}</span>
    <span className={classes.menuItemLabel}>{label}</span>
    {rightLabel && <span className={classes.menuItemRight}>{rightLabel}</span>}
    {!rightLabel && <ChevronIcon />}
  </button>
);

const MAX_PHOTO_BYTES = 5 * 1024 * 1024;
const ALLOWED_PHOTO_TYPES = ['image/jpeg', 'image/png'];

// Matches .container/.backdrop's slideOut/fadeOut animation-duration in
// HamburgerMenu.module.css — kept in sync so the component unmounts exactly
// when the exit animation finishes, not before (which would cut it off and
// look like a glitch) or after (a dead frame with nothing to show).
const CLOSE_ANIM_MS = 250;

const HamburgerMenu = ({ visible, setMenuVisible, group, setCurrentScreen }) => {
  const [showInfoModal, setShowInfoModal] = useState(false);
  const [showResourcesModal, setShowResourcesModal] = useState(false);
  const [showPartnerModal, setShowPartnerModal] = useState(false);
  const [showEventsSheet, setShowEventsSheet] = useState(false);
  const [showMyProfile, setShowMyProfile] = useState(false);
  const [uploadingPhoto, setUploadingPhoto] = useState(false);
  const photoInputRef = useRef(null);

  // `visible` flipping to false used to unmount the menu on the very same
  // render — with no exit animation ever getting a chance to play, it just
  // vanished instantly (the "glitch" on return to the main screen). `mounted`
  // keeps it rendered for one extra animation cycle so slideOut/fadeOut can
  // actually run before it's removed from the DOM.
  const [mounted, setMounted] = useState(visible);
  const [closing, setClosing] = useState(false);

  useEffect(() => {
    if (visible) {
      setMounted(true);
      setClosing(false);
    } else if (mounted) {
      setClosing(true);
      const timer = setTimeout(() => {
        setMounted(false);
        setClosing(false);
      }, CLOSE_ANIM_MS);
      return () => clearTimeout(timer);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visible]);
  const UserCtx = useContext(UserContext);
  const { requestLogin } = useContext(AuthenticatedUserContext);
  const user = auth.currentUser;
  const isGuest = !user || user.isAnonymous;
  const settings = UserCtx?.settings;
  const festivalName = group?.festival?.name || 'No event selected';

  const handleSignout = () => signOut(auth).catch(err => console.log(err));
  const handleContact = () => window.open('https://www.greenmusic.org.au/contact', '_blank');
  const handleTerms = () => window.open('https://www.campingbuddy.com.au/terms_of_service', '_blank');
  const handleHelp = () => window.open('https://www.campingbuddy.com.au/help', '_blank');
  const handleSignUp = () => {
    // Opens the real Login/Auth screen (via RootNavigator, one level up).
    // If this is a lingering anonymous session, sign out too so it doesn't
    // keep routing back into the app on next load.
    if (user?.isAnonymous) signOut(auth).catch(() => {});
    requestLogin && requestLogin('signup');
    setMenuVisible(false);
  };

  const handleAvatarClick = () => {
    if (isGuest || uploadingPhoto) return;
    photoInputRef.current?.click();
  };

  const handlePhotoChange = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = '';
    if (!file) return;
    if (!ALLOWED_PHOTO_TYPES.includes(file.type)) {
      alert('Please choose a JPG or PNG image.');
      return;
    }
    if (file.size > MAX_PHOTO_BYTES) {
      alert('Please choose an image under 5MB.');
      return;
    }
    setUploadingPhoto(true);
    try {
      const photoRef = storageRef(storage, `users/${user.uid}/profile-photo`);
      await uploadBytes(photoRef, file);
      const url = await getDownloadURL(photoRef);
      await updateDoc(doc(db, 'users', user.uid), { photoURL: url });
    } catch (err) {
      alert('There was a problem uploading your photo.');
    }
    setUploadingPhoto(false);
  };

  if (!mounted) return null;

  if (showInfoModal) return <Page setShowPage={setShowInfoModal} id='JvZkMBggZUVzN2w4PDwM' />;
  if (showResourcesModal) return <Page setShowPage={setShowResourcesModal} id='bLoDr1AAmDOo4tj7cRWo' />;
  if (showPartnerModal) return <Page setShowPage={setShowPartnerModal} id='YCWSnkNTRyRGTp3l5Xj5' />;
  if (showEventsSheet) {
    return (
      <EventsSheet
        onClose={() => setShowEventsSheet(false)}
        onLeave={() => {
          setShowEventsSheet(false);
          setMenuVisible(false);
          setCurrentScreen('home');
        }}
      />
    );
  }
  if (showMyProfile) {
    return (
      <MyProfile
        settings={settings}
        onClose={() => setShowMyProfile(false)}
      />
    );
  }

  return ReactDOM.createPortal(
    <div className={classes.overlay}>
      <div className={`${classes.backdrop} ${closing ? classes.backdropClosing : ''}`} onClick={() => setMenuVisible(false)} />
      <div className={`${classes.container} ${closing ? classes.containerClosing : ''}`}>
      <div className={classes.inner}>

        {/* Close button */}
        <button className={classes.closeBtn} onClick={() => setMenuVisible(false)}>
          <XIcon />
        </button>

        {/* Profile section */}
        <div className={classes.profile}>
          <button
            className={classes.avatarCircle}
            onClick={handleAvatarClick}
            disabled={isGuest || uploadingPhoto}
            aria-label="Change profile photo"
          >
            {settings?.photoURL ? (
              <img src={settings.photoURL} alt="" className={classes.avatarImage} />
            ) : (
              <UserIcon />
            )}
          </button>
          {!isGuest && (
            <input
              ref={photoInputRef}
              type="file"
              accept="image/jpeg,image/png"
              onChange={handlePhotoChange}
              style={{ display: 'none' }}
            />
          )}
          <div className={classes.profileText}>
            <div className={classes.profileName}>{isGuest ? 'Guest' : settings?.name || 'User'}</div>
            {!isGuest && settings?.email && (
              <div className={classes.profileEmail}>{settings.email}</div>
            )}
          </div>
        </div>

        {/* Main menu items */}
        <div className={classes.menuCard}>
          {!isGuest && (
            <MenuItem icon={MENU_ICONS.profile} label="My Profile" onClick={() => setShowMyProfile(true)} />
          )}
          {!isGuest && (
            <>
              <div className={classes.divider} />
              <MenuItem
                icon={MENU_ICONS.events}
                label="My events"
                rightLabel={festivalName.length > 16 ? festivalName.slice(0, 16) + '...' : festivalName}
                onClick={() => setShowEventsSheet(true)}
              />
              <div className={classes.divider} />
            </>
          )}
          <MenuItem icon={MENU_ICONS.about} label="About" onClick={() => setShowInfoModal(true)} />
          <div className={classes.divider} />
          <MenuItem icon={MENU_ICONS.resources} label="Resources" onClick={() => setShowResourcesModal(true)} />
          <div className={classes.divider} />
          {/* Partners page hidden for now — reinstate by uncommenting this
              MenuItem + divider (see also showPartnerModal state above). */}
          {/* <MenuItem icon={MENU_ICONS.partners} label="Partners" onClick={() => setShowPartnerModal(true)} />
          <div className={classes.divider} /> */}
          <MenuItem icon={MENU_ICONS.terms} label="Terms of service" onClick={handleTerms} />
          <div className={classes.divider} />
          <MenuItem icon={MENU_ICONS.contact} label="Contact us" onClick={handleContact} />
          <div className={classes.divider} />
          <MenuItem icon={MENU_ICONS.help} label="Help" onClick={handleHelp} />
        </div>

        {/* Bottom card */}
        <div className={classes.menuCard}>
          {!isGuest ? (
            <MenuItem icon={MENU_ICONS.logout} label="Log out" onClick={handleSignout} />
          ) : (
            <MenuItem icon={MENU_ICONS.signup} label="Sign up" onClick={handleSignUp} />
          )}
        </div>

      </div>
      </div>
    </div>,
    document.body
  );
};

export default HamburgerMenu;
